import React, { useState, useEffect, useRef } from 'react'

import { Tab as TabType } from 'types/searchV2'

import Tab from 'components/cardSearchPanel/tabs/tab'
import GlobalOverlayStack from 'components/elements/Overlay/GlobalOverlayStack'

import styles from './searchV2.module.scss'

type Props = {
  open: boolean
  onClose: () => void
  searchTab?: TabType
  header?: string
}

const SearchV2Standalone = ({ open, onClose, searchTab, header }: Props) => {
  const scrollRef = useRef<HTMLDivElement>(null)

  const [tab, setTab] = useState<TabType>()

  useEffect(() => {
    if (!open) return
    if (!searchTab) return

    setTab(searchTab)
  }, [searchTab])

  const handleBackToTop = (behavior: 'auto' | 'instant' | 'smooth' = 'smooth') =>
    scrollRef?.current?.scrollTo({ top: 0, behavior: behavior })

  return (
    <GlobalOverlayStack
      ref={scrollRef}
      open={open}
      onClose={onClose}
      className={styles.container}
      mobileToolbarOptions={[
        { icon: 'arrow circle up', label: 'Scroll up', onClick: () => handleBackToTop('smooth') },
      ]}>
      {tab && (
        <Tab header={header} tab={tab} onTabUpdate={setTab} active scrollToTop={() => handleBackToTop('smooth')} />
      )}
    </GlobalOverlayStack>
  )
}

export default SearchV2Standalone
